/**
 * 简单封装第三方的统计
 * 百度统计：https://tongji.baidu.com/web/help/article?id=236&type=0
 * 友盟统计：https://developer.umeng.com/docs/67963/detail/74512
 */
declare global{
    interface Window{
        _hmt: {
            push: (arr: any[]) => void;
        };
    }
}

// 全站的category枚举
export const StatisticCategory = {
    UserCenter: '个人中心',
    Record: '答题记录',
};

interface  Args {
    // category：事件类别，必填项，表示事件发生在谁身上，如“视频”、“小说”、“轮显层”等等。要监控的目标的类型名称，通常是同一组目标的名字，比如”视频”、”音乐”、”软件”、”游戏”等等。该项必选
    category: string;
    // action：事件操作，必填项，表示访客跟元素交互的行为动作，如”播放”、”收藏”、”翻层”等等。用户跟目标交互的行为，如”播放”、”暂停”、”下载”等等
    action: string;
    // label：事件标签，选填项，用于更详细的描述事件，从各个方面都可以，比如具体是哪个视频，哪部小说，翻到了第几层等等。事件的一些额外信息，通常可以是歌曲的名称、软件的名称、链接的名称等等
    label?: string;
    // value：事件值，选填项，整数型，用于填写打分型事件的分值，加载时间型事件的时长，订单型事件的价格等等。事件的一些数值信息，比如权重、时长、价格等等，在报表中可以看到其平均值等数据
    value?: string;
    // nodeid：div元素id，选填项，填写网页中的div元素id值
    nodeid?: string;
}
export function statistic(args: Args) {
    try {
        window._hmt.push(['_trackEvent', args.category, args.action, args.label, args.value]);
    } catch(err) {
        console.error('third party statistic send error!', err);
    }
}
